import { render, staticRenderFns } from "./SafetyFreeTextReportView.vue?vue&type=template&id=0a9f3d5a&scoped=true"
import script from "./SafetyFreeTextReportView.vue?vue&type=script&lang=ts"
export * from "./SafetyFreeTextReportView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9f3d5a",
  null
  
)

export default component.exports